module.exports = __webpack_public_path__ + "static/logo-footer-a45f6b38c0868b8d7709dfae95c2b33d.png";